import { Eye, EyeOff } from "lucide-react"
import { useTranslation } from "react-i18next"
import { setViewMode, useViewMode } from "./viewMode"

const LABELS: Record<string, { clean: string; technical: string; hint: string }> = {
  ru: { clean: "Чистый чат", technical: "Технический чат", hint: "Переключить вид чата" },
  de: { clean: "Sauberer Chat", technical: "Technischer Chat", hint: "Chat-Ansicht umschalten" },
  en: { clean: "Clean chat", technical: "Technical chat", hint: "Switch chat view" },
}

export function ViewModeToggle() {
  const { i18n } = useTranslation("chat")
  const mode = useViewMode()
  const l = LABELS[(i18n.language || "en").slice(0, 2)] ?? LABELS.en
  const technical = mode === "technical"
  return (
    <button
      type="button"
      onClick={() => setViewMode(technical ? "clean" : "technical")}
      title={l.hint}
      className="flex items-center gap-1.5 rounded-[4px] border border-[#2a364b] bg-[#172133] px-3 py-1.5 text-xs text-[#e8eef8] transition-colors hover:border-[#46617f] hover:bg-[#1b2536]"
    >
      {technical ? <Eye size={12} /> : <EyeOff size={12} />}
      {technical ? l.technical : l.clean}
    </button>
  )
}
